import { Link, useParams, useLocation } from 'react-router-dom';
import { BarChart3, ShoppingCart, Tag, Ticket, UserPlus, ArrowLeft, Mail, FileText, Users } from 'lucide-react';

const EventSubNav = ({ eventTitle }) => {
  const { eventId } = useParams();
  const location = useLocation();
  
  const navItems = [
    { path: `/admin/eventos/${eventId}`, label: 'Resumen', icon: BarChart3, exact: true },
    { path: `/admin/eventos/${eventId}/ordenes`, label: 'Órdenes', icon: ShoppingCart },
    { path: `/admin/eventos/${eventId}/descuentos`, label: 'Descuentos', icon: Tag },
    { path: `/admin/eventos/${eventId}/tandas`, label: 'Tandas', icon: Ticket },
    { path: `/admin/eventos/${eventId}/vendedores`, label: 'Vendedores', icon: UserPlus },
    { path: `/admin/eventos/${eventId}/invitaciones`, label: 'Invitaciones', icon: Mail },
    { path: `/admin/eventos/${eventId}/reportes`, label: 'Reportes', icon: FileText },
    { path: `/admin/eventos/${eventId}/rrpp`, label: 'RRPP', icon: Users },
  ];

  const isActive = (item) => {
    if (item.exact) {
      return location.pathname === item.path;
    }
    return location.pathname.startsWith(item.path);
  };

  return (
    <div className="mb-8">
      {/* Back link */}
      <Link 
        to="/admin/eventos" 
        className="inline-flex items-center text-[#A1A1AA] hover:text-white mb-4 transition-colors"
      >
        <ArrowLeft size={16} className="mr-2" />
        Volver a Eventos
      </Link>
      
      {/* Event title */}
      {eventTitle && (
        <h1 className="text-3xl font-black tracking-tighter uppercase mb-6">
          {eventTitle}
        </h1>
      )}
      
      {/* Sub navigation */}
      <nav className="flex gap-1 border-b border-[#27272A]">
        {navItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`px-4 py-3 text-sm font-medium uppercase tracking-wider flex items-center gap-2 transition-colors border-b-2 -mb-px ${
              isActive(item)
                ? 'text-white border-white' 
                : 'text-[#A1A1AA] border-transparent hover:text-white hover:border-[#52525B]'
            }`}
          >
            <item.icon size={16} />
            {item.label}
          </Link>
        ))}
      </nav>
    </div>
  );
};

export default EventSubNav;
